import { Component } from '@angular/core';

import { Store } from '@ngxs/store';

import { LoginWithRedirect } from '../../../../state/app.actions';

@Component({
  selector: 'sh-main-nav-login',
  templateUrl: './main-nav-login.component.html',
  styleUrl: './main-nav-login.component.scss',
  standalone: false
})
export class MainNavLoginComponent {
  constructor(private _store: Store) {}

  onLoginButtonClick(): void {
    this._store.dispatch(new LoginWithRedirect());
  }
}
